"use client";
import { Box, InputAdornment, Stack, Typography } from "@mui/material";
import { AppImage, AppTextField } from "@/common";
import { CloseEyePasswordIcon, OpenEyePasswordIcon } from "@/icons";
import { LoginRequestType, signInschema } from "@/models";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import AppButton from "@/common/AppButton";
// import { authenticateAction } from "@/actions/auth-action";
import { enqueueSnackbar } from "notistack";
import { AppConstant, PathConstant } from "@/const";
import { zodResolver } from "@hookform/resolvers/zod";
import { signInAction } from "@/actions/auth-action";
import { useRouter } from "next/navigation";
const LoginClient = () => {
  const router = useRouter();
  const [isShowPassword, setIsShowPassword] = useState<boolean>();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<LoginRequestType>({
    resolver: zodResolver(signInschema),
  });

  const handleClickShowPassword = () => setIsShowPassword((show) => !show);
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    setIsReady(true);
    return () => {};
  }, []);

  const inputStyle = { WebkitBoxShadow: "0 0 0 1000px white inset" };
  const submitData = async (data: LoginRequestType) => {
    data.rememberMe = false;
    data.returnUrl = "";
    const session = await signInAction(data);
    console.log("signInAction session", session);
    if (session) {
      enqueueSnackbar({
        message: "Đăng nhập thành công",
        variant: AppConstant.SUCCEED_VARIANT,
      });
      router.push(PathConstant.HOME);
    } else {
      enqueueSnackbar({
        message: "Đăng nhập không thành công",
        variant: AppConstant.ERROR_VARIANT,
      });
    }
  };

  return (
    <Stack
      className="bg-login p-5 min-h-app"
      justifyContent="center"
      alignItems="center"
      flexWrap="wrap"
    >
      <Box
        component="form"
        className="p-10 rounded-4 bg-white w-full"
        sx={{
          maxWidth: "490px",
        }}
        onSubmit={handleSubmit(submitData)}
      >
        {/* <Typography className="text-center mt-1 mb-3" variant="h5">
          Hệ thống quản trị
        </Typography> */}
        <Box className="text-center flex items-center justify-center object-contain">
          <AppImage
            src={"/images/logo-dark.png"}
            width={"120px"}
            height={"100px"}
            alt="logo"
            className="object-cover"
          />
        </Box>

        <Box className="mt-4">
          <AppTextField
            placeholder="Tài khoản"
            fullWidth
            size="small"
            error={Boolean(errors.userName)}
            helperText={errors.userName?.message}
            {...register("userName")}
            inputProps={{ style: inputStyle }}
            InputProps={{
              sx: {
                borderRadius: "8px",
              },
            }}
          />
        </Box>
        <Box className="mt-4">
          <AppTextField
            placeholder="Mật khẩu"
            fullWidth
            type={isShowPassword ? "text" : "password"}
            size="small"
            {...register("password")}
            error={Boolean(errors.password)}
            helperText={errors.password?.message}
            inputProps={{ style: inputStyle }}
            InputProps={{
              className: "rounded-2 pr-0 mt-4",
              endAdornment: (
                <InputAdornment
                  onClick={handleClickShowPassword}
                  className="cursor-pointer h-full ml-0 pr-2 px-2 h2"
                  position="end"
                >
                  {isShowPassword ? (
                    <OpenEyePasswordIcon />
                  ) : (
                    <CloseEyePasswordIcon />
                  )}
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box className="mt-8">
          <AppButton
            variant="contained"
            color="primary"
            size="xxlarge"
            className="w-full"
            type="submit"
            disabled={isSubmitting || !isReady}
          >
            {isSubmitting ? "Đang đăng nhập..." : "Đăng nhập"}
          </AppButton>
        </Box>
      </Box>
    </Stack>
  );
};

export default LoginClient;
